import BrandMark from './BrandMark';
import './NotFound.css';

function NotFound() {
  return (
    <div className="not-found">
      <div className="not-found-brand">
        <BrandMark className="not-found-logo" />
        <span className="not-found-brand-name">Sundaravel Group</span>
      </div>

      <div className="not-found-body">
        <h1 className="not-found-heading">Page Not Found</h1>
        <p className="not-found-text">
          Sorry, we couldn't find the page you're looking for. The URL you entered may be
          incorrect or may not be available. Please check the address and try again. If
          everything seems correct, the page may have been moved, updated, or removed.
        </p>
        <a href="/" className="btn btn-primary not-found-home">
          Take Me Home
        </a>
      </div>
    </div>
  );
}

export default NotFound;
